'use client';

import {
  useGetRecommendedProducts,
  useGetStrategyRecommendedProducts,
} from '@/common/apis/recommendations/recommendations';
import Wrapper from '@/common/components/wrapper/wrapper.component';
import RecommendationSection from './recommendation-section.component';

interface OtherProductsProps {
  productId: number;
  vendorId?: number;
}

function OtherProducts({ productId, vendorId }: OtherProductsProps) {
  const similarProducts = useGetStrategyRecommendedProducts({
    query: { productId, strategy: 'CategoryBased', count: 20 },
  });
  const boughtTogetherProducts = useGetRecommendedProducts({
    query: { productId, vendorId },
  });
  const vendorProducts = useGetStrategyRecommendedProducts({
    query: { productId, strategy: 'VendorBased', count: 20 },
  });
  const recommendationQueries = [
    similarProducts,
    boughtTogetherProducts,
    vendorProducts,
  ];
  const hasVisibleSection = recommendationQueries.some(
    ({ data, isError, isLoading }) =>
      isLoading || (!isError && Boolean(data?.data.recommendedProducts?.length))
  );

  if (!hasVisibleSection) return null;

  return (
    <Wrapper className="flex justify-center lg:px-0">
      <div className="flex w-full flex-col gap-10 overflow-hidden pb-[92px] lg:gap-14">
        <RecommendationSection
          title="محصولات مشابه"
          products={similarProducts.data?.data.recommendedProducts}
          isError={similarProducts.isError}
          isLoading={similarProducts.isLoading}
        />
        <RecommendationSection
          title="در کنارش خریداری شده"
          products={boughtTogetherProducts.data?.data.recommendedProducts}
          isError={boughtTogetherProducts.isError}
          isLoading={boughtTogetherProducts.isLoading}
        />
        <RecommendationSection
          title="سایر محصولات این فروشگاه"
          products={vendorProducts.data?.data.recommendedProducts}
          isError={vendorProducts.isError}
          isLoading={vendorProducts.isLoading}
        />
      </div>
    </Wrapper>
  );
}

export default OtherProducts;
